import { CommerceProps } from "codat-data-ui/Commerce";
import React, { lazy } from "react";

import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";
import PageLoadingSkeleton from "components/PageLoadingSkeleton";

const RemoteCommerce = lazy(() =>
  import("codat-data-ui/Commerce").then((module) => ({
    default: module.default,
  }))
);

const Commerce = ({ companyId }: CommerceProps) => (
  <React.Suspense fallback={<PageLoadingSkeleton />}>
    <ErrorBoundary>
      <RemoteCommerce companyId={companyId} />
    </ErrorBoundary>
  </React.Suspense>
);

export default Commerce;
